import { createAsyncThunk } from "@reduxjs/toolkit";
//Include Both Helper File with needed methods


export const getRevenueChartsData = createAsyncThunk("dashboard/getRevenueChartsData", async (data : any) => {
  try {
    var response;

    return response;
  } catch (error) {
    return error;
  }
});